import { Listeners } from '../utils.js';

// Global click outside handler
let globalClickHandler = null;

class CosTooltip extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.settings = JSON.parse(this.dataset.settings || '{}');
    this.timeoutId = null;
    this.isClickMode = false; // Track if tooltip was opened by click
    
    // Set up global click outside handler if not already set
    if (!globalClickHandler) {
      globalClickHandler = (e) => {
        document.querySelectorAll('cos-tooltip.tooltip--visible').forEach((tooltip) => {
          if (!tooltip.contains(e.target)) {
            tooltip.classList.remove('tooltip--visible');
            tooltip.isClickMode = false; // Reset click mode when closing
          }
        });
      };
      document.addEventListener('click', globalClickHandler);
    }
    
    this.listeners.add(this, 'click', (e) => {
      e.stopPropagation();
      
      // Close all other tooltips first
      document.querySelectorAll('cos-tooltip.tooltip--visible').forEach((tooltip) => {
        if (tooltip !== this) {
          tooltip.classList.remove('tooltip--visible');
          tooltip.isClickMode = false; // Reset click mode for other tooltips
        }
      });
      
      // Clear any existing timeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      
      if (this.classList.contains('tooltip--visible')) {
        this.classList.remove('tooltip--visible');
        this.isClickMode = false;
        return;
      }
      
      this.classList.add('tooltip--visible');
      this.isClickMode = true; // Mark as opened by click
    });
    
    // Hover behavior with timeout
    this.listeners.add(this, 'mouseover', () => {
      // Don't interfere if tooltip is in click mode
      if (this.isClickMode) {
        return;
      }
      
      // Close all other tooltips first
      document.querySelectorAll('cos-tooltip.tooltip--visible').forEach((tooltip) => {
        if (tooltip !== this) {
          tooltip.classList.remove('tooltip--visible');
          tooltip.isClickMode = false; // Reset click mode for other tooltips
        }
      });
      
      // Clear any existing timeout
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      
      this.classList.add('tooltip--visible');
    });

    this.listeners.add(this, 'mouseout', () => {
      // Don't close if tooltip is in click mode
      if (this.isClickMode) {
        return;
      }
      this.timeOutClose();
    });
  }

  disconnectedCallback() {
    if (this.listeners) {
      this.listeners.removeAll();
    }
  }

  timeOutClose() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.classList.remove('tooltip--visible');
      this.timeoutId = null;
    }, this.settings.timeout || 2000);
  }
}

if (!customElements.get('cos-tooltip')) customElements.define('cos-tooltip', CosTooltip);
